import * as React from 'react'
import { customerGroupsStore } from '../../../../../factories/database/customer-groups-store'
import { PartialCustomerGroup } from '../types'
import { prioritizeDefaultGroup } from './utils'

/**
 * Custom hook to get all customer groups from the IndexDB store
 * @returns PartialCustomerGroup[] - An array of customer groups
 * @note Created for the services modal to display customer groups, but can be used elsewhere if needed
 */
export function useCustomerGroups() {
  const [allCustomerGroups, setAllCustomerGroups] = React.useState<
    PartialCustomerGroup[]
  >([])

  React.useEffect(() => {
    customerGroupsStore.all().then(groups => {
      if (!groups) return
      const allGroups = groups.map(group => ({
        // map the IndexDB values to the expected shape of PartialCustomerGroup
        id: group.id || '',
        name: group.name || '',
        groupId: group.group_id || '',
      }))

      // sort the groups with the default group (All Customers) first
      const reorderedGroups = prioritizeDefaultGroup(allGroups)
      setAllCustomerGroups(reorderedGroups)
    })
  }, [])
  return allCustomerGroups
}
